<script setup lang="ts">
import type { Settings } from '@/lib/trashsim/settings';
import type { Wave } from '@/lib/trashsim';

defineProps<{
    wave: Wave
    settings: Settings
}>()
const emits = defineEmits<{
    (e: 'simulate'): void
}>()

const simulate = () => emits('simulate')
const share = () => console.log('share not implemented')

</script>

<template>
    <div class="top-content">
        <div id="simulate-button" class="btn btn-light" @click="simulate">{{ $t('home.simulate') }}</div>
        <div id="share-button" class="btn btn-light btn-disabled btn-top" @click="share"></div>
        <div id="save-button" class="btn btn-light btn-disabled btn-top"></div>
    </div>
</template>

<style scoped>
.top-content {
    display: -webkit-flex;
    display: -ms-flex;
    display: flex;
    margin-bottom: 15px;

}
.top-content #simulate-button {
    -webkit-flex: auto;
    -ms-flex: auto;
    flex: auto;
}
.top-content .btn-top {
    padding: 6.5px;
    margin-left: 10px;
}
.top-content .btn-top img {
    height: 25px;
    display: block;
}

@media (max-width: 37em) {
    .top-content {
        width: 100%;
        float: none;
        margin-bottom: 2%;
    }
}

@media (max-width: 50em) {
    .top-content {
        width: 49%;
        float: right;
    }
}
</style>